var _defs, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eb1bcff4a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 120.375 112.5 L 254.625 112.5 L 254.625 262.5 L 120.375 262.5 Z M 120.375 112.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb1bcff4a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0277bd",
    d: "M 254.605469 112.5 L 120.394531 112.5 L 132.238281 246.710938 L 187.5 262.5 L 242.761719 246.710938 Z M 254.605469 112.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M 187.5 124.34375 L 187.5 250.261719 L 231.710938 237.632812 L 241.578125 124.34375 Z M 187.5 124.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 223.421875 144.078125 L 187.5 144.078125 L 187.5 159.867188 L 206.84375 159.867188 L 205.65625 175.65625 L 187.5 175.65625 L 187.5 191.449219 L 204.867188 191.449219 L 203.683594 209.210938 L 187.5 214.738281 L 187.5 231.316406 L 218.683594 221.050781 L 221.449219 175.65625 Z M 223.421875 144.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeeeee",
    d: "M 187.5 144.078125 L 187.5 159.867188 L 152.367188 159.867188 L 151.183594 144.078125 Z M 169.34375 175.65625 L 170.132812 191.449219 L 187.5 191.449219 L 187.5 175.65625 Z M 170.921875 199.34375 L 155.132812 199.34375 L 156.316406 221.050781 L 187.5 231.316406 L 187.5 214.738281 L 171.316406 209.210938 Z M 170.921875 199.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.d94e791769fb53184621fa6400a5a7f6.svg";
export { ForwardRef as ReactComponent };